var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SliderBannerComponent"},[_c('v-carousel',{attrs:{"hide-delimiters":"","height":"auto","cycle":""}},_vm._l((_vm.images),function(image,key){return _c('v-carousel-item',{key:key,attrs:{"src":image}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }